import { IncludeType } from '../../../common';
import { Product } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getProduct = async (
  productId: number,
  locale: string,
  includeType?: IncludeType
): Promise<Product | null> => {
  try {
    const queryParams = new URLSearchParams({
      include: includeType || IncludeType.Available,
      marketLocale: locale,
    });

    const url = `product/${productId}?${queryParams.toString()}`;
    const response = await productCatalogueHttp.get<Product>(url);

    return response.data || null;
  } catch (error) {
    console.error(`Error fetching product with ID ${productId}:`, error);
    return null;
  }
};
